import { defineComponent as r, createBlock as o, openBlock as n, unref as i, mergeProps as c, withCtx as s, renderSlot as l } from "vue";
import { NIcon as a } from "./highrise462.mjs";
const d = r({
  name: "HLIcon",
  inheritAttrs: !0
}), p = /* @__PURE__ */ r({
  ...d,
  props: {
    id: {
      type: String
    },
    size: {
      type: [Number, String],
      default: "16"
    },
    color: String
  },
  setup(e) {
    return (t, u) => (n(), o(i(a), c({
      id: e.id,
      class: "hr-icon-inner",
      size: e.size,
      color: e.color
    }, t.$attrs), {
      default: s(() => [
        l(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["id", "size", "color"]));
  }
});
export {
  p as default
};
